
<template>

	<mymodal ref="modal" title="Загрузить фильтр" ok="Загрузить" :reset="reset" :submit="submit" :check="check" :ok_disabled="ok_disabled">

		<b-form-input v-model="name" v-on:input="name => search(name)" placeholder="Поиск"/>

		<b-table style="font-size: 10pt;" small striped hover :items="filters_visible" :fields="fields" class="mt-2" select-mode="single" selectable selected-variant="primary" v-on:row-selected="select_one"/>

	</mymodal>

</template>

<script>

import api from "../../api"
import mymodal from "../widgets/modal"

export default
{
	props :
	{
		essence : String,
	},

	components :
	{
		mymodal,
	},

	data()
	{
		return {
			
			filters : [],
			filters_visible : [],
			selected : null,

			fields :
			[
				{ key : "name", label : "Наименование", sortable : true },
			],

			name : null,
			ok_disabled : true,

		}
	},

	methods :
	{
		reset()
		{
			this.selected = null
			this.name = null
			this.ok_disabled = true
		},

		check()
		{
			return this.selected != null
		},

		execute()
		{
			var query

			if(this.essence == "cadastral_objects" || this.essence == "cadastral_analogues")
				query = { "$or" : [ { essence : "cadastral_objects" }, { essence : "cadastral_analogues" } ] }
			else
				query = { essence : this.essence }

			api.call(this, "filters", "get_many", { query : query },
				response =>
				{
					var filters = response.data

					this.filters = filters
					this.filters_visible = filters
				})

			this.$refs.modal.execute()
		},

		submit()
		{
			if(this.selected != null)
			{
				const flt = this.filters.find(flt => flt.id == this.selected.id)

				this.$emit("load", { query : flt.filter, name : flt.name })
			}
		},

		search(name)
		{
			if(name == null)
				name = this.name

			const exp = new RegExp(name, "i")

			this.filters_visible = this.filters.filter(elem =>
				( elem.name.match(exp) || name == null )
			)
		},

		select_one(selected)
		{
			this.selected = selected.length ? selected[0] : []
			this.ok_disabled = selected.length == 0
		},
	}
}

</script>

